export const environment = {
  production: false,
  api_url: 'https://api-staging.coincuriosity.us/api/',
  token_lable: '__cc@Auth_staging__',
  stripe_key: "pk_test_51QiFFDAuHNLSjzg2u2QXC6sz5x3jJQW04QxklzGz4R0eszFSRZQOiFKJUlU337MFNVJyMNosqcO7Nd8BCSrQJaz500nqMZSqxJ"
};
